<template>
	<div class="sidebar_warp">
		<div class="logo flex flex-x-center flex-y-center">
			<img src="@/assets/images/logobk.png" alt="" />
		</div>
		<div class="menuList">
			<div class="menuItem" v-for="(item, index) in menuList" :key="index" @mouseenter="showMenu(index)">
				<img class="menuItem_icon" :class="{ colGray: selectIndex == index }" :src="item.icon" alt="" />
				<div class="col-fff" :class="{ colGray: selectIndex == index }">
					{{ item.text }}
				</div>
				<div class="second_list scroll-view second_list_unset" @mouseleave="hideMenu()" :style="
            index >= 7 && item.children.length >= 3
              ? 'bottom:-10px'
              : index == 0 && item.children.length >= 5
              ? 'top:0px'
              : ''
          " v-show="selectIndex == index">
					<div class="second-item sc" v-for="item1 in item.children" :key="item1.id" @click="addTab(item1)">
						<span class="col-fff"> {{ item1.text }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		watchEffect,
		reactive,
		toRefs,
		onMounted,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		useRouter
	} from "vue-router";

	export default defineComponent({
		setup() {
			const data = reactive({
				menuList: [],
				selectIndex: null,
			});

			const store = useStore();
			const router = useRouter();
			const tabsList = computed(store.state.tabsList);
			//显示二级菜单
			const showMenu = (index) => {
				console.log(index);
				data.selectIndex = index;
			};
			// 隐藏二级菜单
			const hideMenu = () => {
				data.selectIndex = null;
			};
			// 二级菜单点击
			const addTab = (item1) => {
				console.log(item1);
				if(item1.id==='F04_01'){
					window.open('vehicleMap', '_blank');
				} else{
					const index = store.state.keeptabsList.findIndex(item => item === item1.attributes.url)
					if (index === -1) {
						store.state.keeptabsList.push(item1.attributes.url);
					}
					
					store.state.tabsList.push(item1);
					let currindex = store.state.tabsList.findIndex(item => item.id === item1.id);
					let currlen = store.state.tabsList.length;
					let tabsIndex = store.state.tabsIndex;
					let newList = deWeightThree(store.state.tabsList);
					let newlen = newList.length;
					store.commit("handleTabsList", newList);
					if (currlen == newlen) {
						store.commit("handleTabsIndex", newlen - 1);
					} else {
						store.commit("handleTabsIndex", currindex);
					}
					
					router.push({
						name: item1.attributes.url,
						replace: true,
					});
				}
			};
			//去重
			const deWeightThree = (list) => {
				let map = new Map();

				list.forEach((item) => {
					map.set(item.id, item);
				});
				let newList = [...map.values()];
				return newList;
			};
			onMounted(() => {
				//data.menuList = store.state.menuList;
				data.menuList = store.state.menuList.filter(item => item.id !== 'F13' && item.id !== 'F07' && item.id !== 'F12'); //首页、审批、消息菜单不显示
			});
			return {
				...toRefs(data),
				showMenu,
				hideMenu,
				addTab,
				deWeightThree,
			};
		},
	});
</script>

<style scoped>
	.sidebar_warp {
		width: 75px;
		height: 100%;
		background: #333333;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 2;
	}

	.logo {
		width: 100%;
		padding-top: 10px;
	}

	.logo img {
		width: 50px;
		height: 50px;
		display: block;
		border-radius: 26px;
	}

	.menuList {
		width: 100%;
		height: calc(100% - 100px);
		margin-top: 20px;
	}

	.menuItem {
		width: 45px;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: relative;
		cursor: pointer;
		margin-left: 15px;
	}

	.menuItem_icon {
		width: 20px;
		height: 20px;
		margin-bottom: 10px;
	}

	.second_list {
		width: 130px;
		max-height: 340px;
		overflow: auto;
		background: #42454c;
		position: absolute;
		left: 60px;
		z-index: 999;
	}

	.second_list_top {
		bottom: -50px !important;
	}

	.second_list_unset {
		top: unset;
	}

	.second-item {
		width: 100%;
		height: 45px;

		display: flex;
		align-items: center;
		justify-content: center;

		cursor: pointer;
	}

	.menuList .menuItem .second-list .second-item span {
		margin-top: 0;
	}

	.colGray {
		-webkit-filter: brightness(85%);
		/*考虑浏览器兼容性：兼容 Chrome, Safari, Opera */
		filter: brightness(85%);
		/* 设置图片的亮度，使其看起来更亮或更暗。如果值是0%，图像会全黑；值是100%，则图像无变化；
  值是100%以上，则图像更亮*/
	}

	.normal-gray {
		-webkit-filter: brightness(100%) !important;
		/*考虑浏览器兼容性：兼容 Chrome, Safari, Opera */
		filter: brightness(100%) !important;
		/* 设置图片的亮度，使其看起来更亮或更暗。如果值是0%，图像会全黑；值是100%，则图像无变化；
  值是100%以上，则图像更亮*/
	}

	.second-item:hover span {
		color: #2EB779 !important;
	}
</style>